const customCSSPropertiesMap = {
    "maxContentWidth": "--awsui-max-content-width-n0urnq",
    "minContentWidth": "--awsui-min-content-width-n0urnq",
    "breadcrumbsGap": "--awsui-breadcrumbs-gap-n0urnq",
    "contentGapLeft": "--awsui-content-gap-left-n0urnq",
    "contentGapRight": "--awsui-content-gap-right-n0urnq",
    "contentHeight": "--awsui-content-height-n0urnq",
    "contentLayoutDefaultHorizontalPadding": "--awsui-content-layout-default-horizontal-padding-n0urnq",
    "contentLayoutMaxContentWidth": "--awsui-content-layout-max-content-width-n0urnq",
    "contentLayoutMainGap": "--awsui-content-layout-main-gap-n0urnq",
    "defaultMaxContentWidth": "--awsui-default-max-content-width-n0urnq",
    "defaultMinContentWidth": "--awsui-default-min-content-width-n0urnq",
    "drawerSize": "--awsui-drawer-size-n0urnq",
    "drawerMinSize": "--awsui-drawer-min-size-n0urnq",
    "bottomDrawerSize": "--awsui-bottom-drawer-size-n0urnq",
    "footerHeight": "--awsui-footer-height-n0urnq",
    "headerGap": "--awsui-header-gap-n0urnq",
    "headerHeight": "--awsui-header-height-n0urnq",
    "layoutWidth": "--awsui-layout-width-n0urnq",
    "mainGap": "--awsui-main-gap-n0urnq",
    "mainOffsetLeft": "--awsui-main-offset-left-n0urnq",
    "mainTemplateRows": "--awsui-main-template-rows-n0urnq",
    "mobileBarHeight": "--awsui-mobile-bar-height-n0urnq",
    "notificationsHeight": "--awsui-notifications-height-n0urnq",
    "offsetTop": "--awsui-offset-top-n0urnq",
    "overlapHeight": "--awsui-overlap-height-n0urnq",
    "navigationWidth": "--awsui-navigation-width-n0urnq",
    "navigationCollapsedWidth": "--awsui-navigation-collapsed-width-n0urnq",
    "splitPanelReportedHeaderSize": "--awsui-split-panel-reported-header-size-n0urnq",
    "splitPanelReportedSize": "--awsui-split-panel-reported-size-n0urnq",
    "splitPanelHeight": "--awsui-split-panel-height-n0urnq",
    "splitPanelMinWidth": "--awsui-split-panel-min-width-n0urnq",
    "splitPanelMaxWidth": "--awsui-split-panel-max-width-n0urnq",
    "toolsMaxWidth": "--awsui-tools-max-width-n0urnq",
    "toolsWidth": "--awsui-tools-width-n0urnq",
    "toolsAnimationStartingOpacity": "--awsui-tools-animation-starting-opacity-n0urnq",
    "contentScrollMargin": "--awsui-content-scroll-margin-n0urnq",
    "flashbarStackDepth": "--awsui-flashbar-stack-depth-n0urnq",
    "flashbarStackIndex": "--awsui-flashbar-stack-index-n0urnq",
    "flashbarStickyBottomMargin": "--awsui-flashbar-sticky-bottom-margin-n0urnq",
    "stackedNotificationsBottomMargin": "--awsui-stacked-notifications-bottom-margin-n0urnq",
    "stackedNotificationsDefaultBottomMargin": "--awsui-stacked-notifications-default-bottom-margin-n0urnq",
    "dropdownDefaultMaxWidth": "--awsui-dropdown-default-max-width-n0urnq",
    "dropdownDefaultMinWidth": "--awsui-dropdown-default-min-width-n0urnq",
    "dropdownContentBorderColor": "--awsui-dropdown-content-border-color-n0urnq",
    "dropdownContentBorderWidth": "--awsui-dropdown-content-border-width-n0urnq",
    "dropdownContentBorderRadius": "--awsui-dropdown-content-border-radius-n0urnq",
    "modalCustomWidth": "--awsui-modal-custom-width-n0urnq",
    "modalCustomHeight": "--awsui-modal-custom-height-n0urnq",
    "spinnerRotatorFrom": "--awsui-spinner-rotator-from-n0urnq",
    "spinnerRotatorTo": "--awsui-spinner-rotator-to-n0urnq",
    "spinnerLineLeftFrom": "--awsui-spinner-line-left-from-n0urnq",
    "spinnerLineLeftTo": "--awsui-spinner-line-left-to-n0urnq",
    "spinnerLineRightFrom": "--awsui-spinner-line-right-from-n0urnq",
    "spinnerLineRightTo": "--awsui-spinner-line-right-to-n0urnq",
    "sliderLabelCount": "--awsui-slider-label-count-n0urnq",
    "sliderTickCount": "--awsui-slider-tick-count-n0urnq",
    "sliderReferenceColumn": "--awsui-slider-reference-column-n0urnq",
    "sliderNextReferenceColumn": "--awsui-slider-next-reference-column-n0urnq",
    "sliderMaxStart": "--awsui-slider-max-start-n0urnq",
    "sliderMinEnd": "--awsui-slider-min-end-n0urnq",
    "sliderRangeInlineSize": "--awsui-slider-range-inline-size-n0urnq",
    "sliderTooltipPosition": "--awsui-slider-tooltip-position-n0urnq",
    "togglesLeftWidth": "--awsui-toggles-left-width-n0urnq",
    "togglesRightWidth": "--awsui-toggles-right-width-n0urnq",
    "promptInputMaxRows": "--awsui-prompt-input-max-rows-n0urnq",
    "promptInputScrollHeight": "--awsui-prompt-input-scroll-height-n0urnq",
    "dragHandleAnimationInlineOffset": "--awsui-drag-handle-animation-inline-offset-n0urnq",
    "dragHandleAnimationBlockOffset": "--awsui-drag-handle-animation-block-offset-n0urnq",
    "styleBackgroundActive": "--awsui-style-background-active-n0urnq",
    "styleBackgroundDefault": "--awsui-style-background-default-n0urnq",
    "styleBackgroundDisabled": "--awsui-style-background-disabled-n0urnq",
    "styleBackgroundHover": "--awsui-style-background-hover-n0urnq",
    "styleBorderColorActive": "--awsui-style-border-color-active-n0urnq",
    "styleBorderColorDefault": "--awsui-style-border-color-default-n0urnq",
    "styleBorderColorDisabled": "--awsui-style-border-color-disabled-n0urnq",
    "styleBorderColorHover": "--awsui-style-border-color-hover-n0urnq",
    "styleColorActive": "--awsui-style-color-active-n0urnq",
    "styleColorDefault": "--awsui-style-color-default-n0urnq",
    "styleColorDisabled": "--awsui-style-color-disabled-n0urnq",
    "styleColorHover": "--awsui-style-color-hover-n0urnq",
    "styleFocusRingBorderColor": "--awsui-style-focus-ring-border-color-n0urnq",
    "styleFocusRingBorderRadius": "--awsui-style-focus-ring-border-radius-n0urnq",
    "styleFocusRingBorderWidth": "--awsui-style-focus-ring-border-width-n0urnq",
    "styleFocusRingBoxShadow": "--awsui-style-focus-ring-box-shadow-n0urnq",
    "styleBoxShadowActive": "--awsui-style-box-shadow-active-n0urnq",
    "styleBoxShadowDefault": "--awsui-style-box-shadow-default-n0urnq",
    "styleBoxShadowDisabled": "--awsui-style-box-shadow-disabled-n0urnq",
    "styleBoxShadowHover": "--awsui-style-box-shadow-hover-n0urnq",
    "styleBackgroundReadonly": "--awsui-style-background-readonly-n0urnq",
    "styleBorderColorReadonly": "--awsui-style-border-color-readonly-n0urnq",
    "styleBoxShadowReadonly": "--awsui-style-box-shadow-readonly-n0urnq",
    "styleColorReadonly": "--awsui-style-color-readonly-n0urnq",
    "styleBackgroundFocus": "--awsui-style-background-focus-n0urnq",
    "styleBorderColorFocus": "--awsui-style-border-color-focus-n0urnq",
    "styleBoxShadowFocus": "--awsui-style-box-shadow-focus-n0urnq",
    "styleColorFocus": "--awsui-style-color-focus-n0urnq",
    "stylePlaceholderColor": "--awsui-style-placeholder-color-n0urnq",
    "stylePlaceholderFontSize": "--awsui-style-placeholder-font-size-n0urnq",
    "stylePlaceholderFontStyle": "--awsui-style-placeholder-font-style-n0urnq",
    "stylePlaceholderFontWeight": "--awsui-style-placeholder-font-weight-n0urnq",
    "styleTabsActiveIndicatorColor": "--awsui-style-tabs-active-indicator-color-n0urnq",
    "styleTabsActiveIndicatorWidth": "--awsui-style-tabs-active-indicator-width-n0urnq",
    "styleTabsActiveIndicatorBorderRadius": "--awsui-style-tabs-active-indicator-border-radius-n0urnq",
    "styleTabsSeparatorColor": "--awsui-style-tabs-separator-color-n0urnq",
    "styleTabsSeparatorWidth": "--awsui-style-tabs-separator-width-n0urnq",
    "alertFocusRingBorderColor": "--awsui-alert-focus-ring-border-color-n0urnq",
    "alertFocusRingBorderRadius": "--awsui-alert-focus-ring-border-radius-n0urnq",
    "alertFocusRingBorderWidth": "--awsui-alert-focus-ring-border-width-n0urnq",
    "alertFocusRingBoxShadow": "--awsui-alert-focus-ring-box-shadow-n0urnq",
    "alertIconColor": "--awsui-alert-icon-color-n0urnq",
    "promptInputStyleBackgroundDefault": "--awsui-prompt-input-style-background-default-n0urnq",
    "promptInputStyleBackgroundDisabled": "--awsui-prompt-input-style-background-disabled-n0urnq",
    "promptInputStyleBackgroundFocus": "--awsui-prompt-input-style-background-focus-n0urnq",
    "promptInputStyleBackgroundHover": "--awsui-prompt-input-style-background-hover-n0urnq",
    "promptInputStyleBackgroundReadonly": "--awsui-prompt-input-style-background-readonly-n0urnq",
    "promptInputStyleBorderColorDefault": "--awsui-prompt-input-style-border-color-default-n0urnq",
    "promptInputStyleBorderColorDisabled": "--awsui-prompt-input-style-border-color-disabled-n0urnq",
    "promptInputStyleBorderColorFocus": "--awsui-prompt-input-style-border-color-focus-n0urnq",
    "promptInputStyleBorderColorHover": "--awsui-prompt-input-style-border-color-hover-n0urnq",
    "promptInputStyleBorderColorReadonly": "--awsui-prompt-input-style-border-color-readonly-n0urnq",
    "promptInputStyleBoxShadowDefault": "--awsui-prompt-input-style-box-shadow-default-n0urnq",
    "promptInputStyleBoxShadowDisabled": "--awsui-prompt-input-style-box-shadow-disabled-n0urnq",
    "promptInputStyleBoxShadowFocus": "--awsui-prompt-input-style-box-shadow-focus-n0urnq",
    "promptInputStyleBoxShadowHover": "--awsui-prompt-input-style-box-shadow-hover-n0urnq",
    "promptInputStyleBoxShadowReadonly": "--awsui-prompt-input-style-box-shadow-readonly-n0urnq",
    "promptInputStyleColorDefault": "--awsui-prompt-input-style-color-default-n0urnq",
    "promptInputStyleColorDisabled": "--awsui-prompt-input-style-color-disabled-n0urnq",
    "promptInputStyleColorFocus": "--awsui-prompt-input-style-color-focus-n0urnq",
    "promptInputStyleColorHover": "--awsui-prompt-input-style-color-hover-n0urnq",
    "promptInputStyleColorReadonly": "--awsui-prompt-input-style-color-readonly-n0urnq",
    "promptInputStylePlaceholderColor": "--awsui-prompt-input-style-placeholder-color-n0urnq",
    "promptInputStylePlaceholderFontSize": "--awsui-prompt-input-style-placeholder-font-size-n0urnq",
    "promptInputStylePlaceholderFontStyle": "--awsui-prompt-input-style-placeholder-font-style-n0urnq",
    "promptInputStylePlaceholderFontWeight": "--awsui-prompt-input-style-placeholder-font-weight-n0urnq",
    "promptInputMenuStyleBackgroundColor": "--awsui-prompt-input-menu-style-background-color-n0urnq",
    "promptInputMenuStyleBorderColor": "--awsui-prompt-input-menu-style-border-color-n0urnq",
    "promptInputMenuStyleBorderRadius": "--awsui-prompt-input-menu-style-border-radius-n0urnq",
    "promptInputMenuStyleBorderWidth": "--awsui-prompt-input-menu-style-border-width-n0urnq",
    "optionBackgroundDefault": "--awsui-option-background-default-n0urnq",
    "optionBackgroundHighlighted": "--awsui-option-background-highlighted-n0urnq",
    "optionBackgroundSelected": "--awsui-option-background-selected-n0urnq",
    "optionColorDefault": "--awsui-option-color-default-n0urnq",
    "optionColorHighlighted": "--awsui-option-color-highlighted-n0urnq",
    "optionColorDisabled": "--awsui-option-color-disabled-n0urnq",
    "optionGroupLabelColor": "--awsui-option-group-label-color-n0urnq",
    "optionFilterMatchBackground": "--awsui-option-filter-match-background-n0urnq",
    "optionFilterMatchColor": "--awsui-option-filter-match-color-n0urnq",
    "progressBarBackgroundColor": "--awsui-progress-bar-background-color-n0urnq",
    "progressBarBorderRadius": "--awsui-progress-bar-border-radius-n0urnq",
    "progressBarHeight": "--awsui-progress-bar-height-n0urnq",
    "progressValueBackgroundColor": "--awsui-progress-value-background-color-n0urnq",
    "styleSliderTrackBackgroundColor": "--awsui-style-slider-track-background-color-n0urnq",
    "styleSliderRangeBackgroundDefault": "--awsui-style-slider-range-background-default-n0urnq",
    "styleSliderRangeBackgroundActive": "--awsui-style-slider-range-background-active-n0urnq",
    "styleSliderHandleBackgroundDefault": "--awsui-style-slider-handle-background-default-n0urnq",
    "styleSliderHandleBackgroundHover": "--awsui-style-slider-handle-background-hover-n0urnq",
    "styleSliderHandleBackgroundActive": "--awsui-style-slider-handle-background-active-n0urnq",
    "styleSliderHandleBorderRadius": "--awsui-style-slider-handle-border-radius-n0urnq",
    "tokenStyleBackgroundDefault": "--awsui-token-style-background-default-n0urnq",
    "tokenStyleBackgroundDisabled": "--awsui-token-style-background-disabled-n0urnq",
    "tokenStyleBackgroundReadOnly": "--awsui-token-style-background-read-only-n0urnq",
    "tokenStyleBorderColorDefault": "--awsui-token-style-border-color-default-n0urnq",
    "tokenStyleBorderColorDisabled": "--awsui-token-style-border-color-disabled-n0urnq",
    "tokenStyleBorderColorReadOnly": "--awsui-token-style-border-color-read-only-n0urnq",
    "tokenStyleDismissColorDefault": "--awsui-token-style-dismiss-color-default-n0urnq",
    "tokenStyleDismissColorDisabled": "--awsui-token-style-dismiss-color-disabled-n0urnq",
    "tokenStyleDismissColorHover": "--awsui-token-style-dismiss-color-hover-n0urnq",
    "tokenStyleDismissColorReadOnly": "--awsui-token-style-dismiss-color-read-only-n0urnq",
    "styleItemCardBackgroundDefault": "--awsui-style-item-card-background-default-n0urnq",
    "styleItemCardBorderColorDefault": "--awsui-style-item-card-border-color-default-n0urnq",
    "styleItemCardBorderRadius": "--awsui-style-item-card-border-radius-n0urnq",
    "styleItemCardBorderWidthDefault": "--awsui-style-item-card-border-width-default-n0urnq",
    "styleItemCardBoxShadowDefault": "--awsui-style-item-card-box-shadow-default-n0urnq",
    "inlineLabelBackgroundColor": "--awsui-inline-label-background-color-n0urnq",
    "containerStyleBorderRadius": "--awsui-container-style-border-radius-n0urnq",
    "groupedControlBorderColor": "--awsui-grouped-control-border-color-n0urnq",
};
export default customCSSPropertiesMap;
//# sourceMappingURL=index.js.map